module.exports = __webpack_public_path__ + "static/media/Image-Milestones2.ec009efa.png";